import React from "react";
import Footer from "../Footer/Footer";
import Navbars from "../Navbar/Navbar";
import ScrollToTop from "../ScrollTop";

export default function PrivacyPolicy() {
  return (
    <div>
      <Navbars />
      <ScrollToTop />
      <div
        style={{
          backgroundColor: "#050810",
          marginTop: "55px",
          color: "white",
        }}
      >
        <div className="container">
          <div
            className="d-flex p-4"
            style={{
              justifyContent: "center",
              alignItems: "center",
              fontFamily: "NunitoBlack",
            }}
          >
            <p style={{ color: "#f9c130", fontSize: "30px" }}>Privacy Policy</p>
          </div>
          <div
            style={{
              fontSize: "17px",
              lineHeight: 2,
              fontFamily: "JosefinSans",
              fontSize: "18px",
            }}
          >
            <p
              style={{
                fontFamily: "NunitoBlack",
                fontSize: "20px",
                color: "#f9c130",
              }}
            >
              1. &nbsp; &nbsp;GENERAL&nbsp;
            </p>
            <p>
              1.1 &nbsp; &nbsp; We, Dwija LLC, an entity registered under the
              laws of New Jersey, United States, with registered office located
              at 241 Forest Ave, Paramus, NJ 07652, United States (hereinafter
              referred to as the “Company”, “We”, “Us” or “Our”) grant
              importance to the confidentiality and security of the information
              We collect from Our Users (as defined hereinafter) and are
              committed to protecting Your privacy.
            </p>
            <p>
              1.2. &nbsp; &nbsp; This privacy policy (“Privacy Policy”) read
              with the applicable terms and conditions and other policies
              published and available at Our mobile application under the name
              and style of “WolfWin: Skill Game Online” available at Google Play
              Store and Apple AppStore (hereinafter referred to as the
              “Platform”) and further read with any other applicable agreements
              or contracts between You (as defined herein below) and the Company
              and its technical processors shall apply to all information as may
              be collected by Us through Our Platform from persons who are using
              or accessing the Platform and/or availing the Services (as defined
              hereinbelow) in any manner (hereinafter referred to as “User”,
              “You” or “Your”,).
            </p>
            <p>
              1.3. &nbsp; &nbsp; This Privacy Policy is an electronic record, in
              the form of an electronic contract, under the Indian Information
              Technology Act, 2000 and the rules made thereunder and the amended
              provisions pertaining to electronic documents/records in various
              statutes as amended by the Information Technology Act, 2000. This
              Privacy Policy does not require any physical, electronic, or
              digital signature and is a legally binding document between the
              User and Us. This document is published in accordance with the
              relevant provisions of the Information Technology Act, 2000 and
              the Information Technology (Intermediary Guidelines and Digital
              Media Ethics Code) Rules, 2021 and the Information Technology
              (Reasonable Security Practices & Procedures & Sensitive Personal
              Data or Information) Rules, 2011 (“SPDI Rules”) issued thereunder,
              which mandate an intermediary, such as the Company, to publish a
              privacy policy for collection, use, storage, transfer/ disclosure
              of Personal Information including Sensitive Personal Information
              (as defined herein below) among other rules and regulations and
              agreements for Users. We reserve the right to change, modify, add,
              or delete portions of the terms of this Privacy Policy, at Our
              sole discretion, at any time, in the manner provided herein.
            </p>
            <p>
              1.4. &nbsp; &nbsp; This Privacy Policy governs and sets forth the
              understanding in relation to the collection, usage, processing,
              storage, and disclosure of the information that We may collect,
              and You may provide to Us in connection with Your use or access of
              any the services, functionalities, features, content, or
              facilities available on the Platform (collectively “Services”).
              You acknowledge that this Privacy Policy as well as other
              applicable terms and conditions of use and such other policies as
              may be framed by Us from time to time and published on the
              Platform mentioned above, together with any other applicable
              agreements or contracts between the You and Us will comprise Our
              collective agreement (“Agreement”) with You in relation to any
              Information Collected (as defined hereinbelow) by Us.
            </p>
            <p>
              1.5. &nbsp; &nbsp; The purpose of this Privacy Policy is to inform
              You about Our collection, usage, processing, storage, security,
              and disclosure of the Information Collected, which may consist of
              Personal Information (as defined herein below) of the nature
              detailed herein, from Users. It is reiterated that this Privacy
              Policy will apply to all Personal Information, including Sensitive
              Personal Information that is collected and processed by Us from
              You for the purpose of, in the course of, or as a result of Your
              use or access of the Services and the Platform.
            </p>
            <p>
              1.6. &nbsp; &nbsp; The use of the term “Personal Information” in
              this Privacy Policy refers to “personal information” as
              statutorily defined under the SPDI Rules read with the Information
              Technology Act, 2000 and includes any information through which
              You are capable of being identified, whether directly or
              indirectly in combination with other information of Yours as may
              be available or likely to be available with Us (“Personal
              Information”). Any reference to Personal Information, for the
              purpose of this Privacy Policy, does not include any anonymized
              information that has been appropriately processed or anonymized in
              a way so as to make it non-identifiable, in order to irreversibly
              prevent its identification.
            </p>
            <p>
              1.7. &nbsp; &nbsp; For the purpose of this Privacy Policy,
              reference to “User” will mean any person(s) who uses, accesses, or
              avails the Platform and the Services in any manner (including
              representatives, legal heirs, executors, administrators, permitted
              assigns and successors in interest of the relevant User as may be
              applicable) and will include any other person(s) jointly
              participating in such use. Further, for the purpose of this
              Privacy Policy, We refer to any individual, group of individuals
              defined under law with whom We have a contractual relationship,
              including merchants, advertisers, deal partners, brands,
              businesses etc. as “Business Partners”; to any individual, group
              of individuals defined under law whose services are used by Us in
              order to provide certain Services to You through Our Platform
              (such as third party payment processing provider and other vendors
              and service providers) as “Service Providers” and to Our
              associate, subsidiary, affiliate and/or group companies as
              “Entities”.
            </p>
            <p>
              1.8. &nbsp; &nbsp; We collect and process the Information
              Collected from You in the manner provided herein, in written or
              electronic form, directly and indirectly, in accordance with this
              Privacy Policy in the course of or as a result of Your use of the
              Platform and the Services, including: when You sign-up on the
              Platform for the Services, through electronic communication with
              You (such as via e-mail), and when You browse, use, or access the
              Platform and/or avail any Services offered through the Platform.
              You acknowledge and accept that certain Personal Information about
              You may be automatically tracked during Your navigation on the
              Platform.
            </p>
            <p>
              1.9. &nbsp; &nbsp; You acknowledge and accept that We may
              advertise certain products and services on the Platform which may
              be facilitated or offered by third-party vendors and hosted or
              made available on third-party websites or applications. Our
              Platform may contain links to such third-party websites or
              applications. The User agrees and understands that such
              third-party website(s) and application(s) are not under Our
              control and are subject to independent terms and policies of third
              parties. Once the User leaves Our servers, use of any information
              provided by the User will be governed by the terms of use and
              privacy policy of the operator of these website(s) and
              application(s). Hence, if You access these links or advertisements
              and submit Your information in connection with and/or for the
              purpose of these third-party products and services, You
              understand, acknowledge and accept that Your information may be
              collected by third party vendors and service providers (offering
              such products or services) and the information submitted by You or
              collected from You may be processed be subject to the relevant
              terms and conditions and policies as may be maintained by relevant
              third-party vendors or service providers on applicable third-party
              platforms. We do not operate or control any activities on
              third-party websites or applications, or the products or services
              offered by any third parties, and We request that You review the
              privacy policy and terms of use on any such third-party websites,
              and of any third parties, before accessing and/or submitting Your
              information on such third-party websites, or to such third
              parties, in any way.
            </p>
            <p>
              1.10. &nbsp; &nbsp; We collect and process Your Personal
              Information for and in connection with the purposes described
              herein subject to Your consent accordance with the Privacy Policy
              and the applicable laws in the United States. Any Information
              Collected is used only for and in connection with Your use of the
              Platform and any Services and strictly in line with Our business
              purposes, including for providing You with useful features and
              functionalities on the Platform, enhancement of the operation of
              the Platform and allowing use of all the listed features, and for
              responding to Your requests/queries in an efficient manner in the
              manner detailed herein.
            </p>
            <p>
              1.11. &nbsp; &nbsp; By registering on or otherwise visiting,
              browsing, accessing, availing or using Our Platform and/or
              Services in any manner and/or providing Us with the Information
              Collected, You acknowledge and accept the practices and policies
              outlined in this Privacy Policy, and hereby consent to Our
              collection, use and disclosure of Your Information Collected in
              accordance with this Privacy Policy. If You are not agreeable to
              this, You may not provide Us with the Information Collected and
              refrain from using this Platform and/or Services provided by Us.
              By using the Platform and/or Services provided by Us, consenting
              to provide Us with and providing Us with any of the Information
              Collected as We may request in connection with the purposes
              mentioned herein, You acknowledge that You accept the practices
              and policies outlined in this Privacy Policy and that these are
              applicable and binding to You as a User of the Platform.
            </p>
            <p>
              1.12. &nbsp; &nbsp; You acknowledge and accept that You are
              lawfully authorized to provide Your information to Us and have the
              legal capacity to do so and to give Your legal consent for the
              collection and processing of such information by Us in the manner
              provided in this Privacy Policy. You hereby consent to Our
              collection and processing of Your Information Collected (including
              Your Personal Information and Sensitive Personal Information) in
              the manner described in this Privacy Policy. If You are an US
              resident who has not attained the age of eighteen years (under
              applicable laws in the jurisdiction You reside in and/or are
              accessing the Platform from), You may only use the Platform and/or
              the Services subject to the grant of consent from Your parent or
              legal guardian. We do not knowingly seek any Personal Information
              (including Sensitive Personal Information) from a person who has
              not attained the age of legal majority (under applicable laws in
              US and any other jurisdiction the person resides in and/or is
              accessing the Platform from). If You are a parent or guardian and
              You are aware that a minor in Your care has provided us with such
              information without Your knowledge and consent, please contact Our
              Grievance Officer in the manner provided in this Privacy Policy.
              If We become aware that We may have collected Personal Information
              (including Sensitive Personal Information) from any minors, We
              will take all reasonable and commercially appropriate steps to
              remove that information from Our servers and/or to deactivate the
              relevant User account associated with such persons as soon as
              reasonably practicable.
            </p>
            <p>
              1.13. &nbsp; &nbsp; You acknowledge and accept that the collection
              and processing of Your Information Collected in accordance with
              this Privacy Policy shall not cause any loss or wrongful gain to
              You or to any other person. You acknowledge that anything done,
              caused to be done, whether expressly or impliedly in contravention
              of this Privacy Policy may render You liable for legal action. We
              shall not be held liable in any manner whatsoever if there is any
              error or deficiency by Us in Our business transaction with You due
              to any information You provide Us which is false or incorrect or
              provided in a manner contrary to this Privacy Policy or due to any
              withdrawal of Your consent. You acknowledge and agree to indemnify
              and hold Us (and Our employees, consultants, directors,
              representatives, and affiliates) harmless from any complaints,
              legal proceedings or claims filed or initiated by any third party
              against Us due to any breach by You of the terms of this Privacy
              Policy through any act or omission attributable to You.
            </p>
            <p
              style={{
                fontFamily: "NunitoBlack",
                fontSize: "20px",
                color: "#f9c130",
              }}
            >
              2. &nbsp; &nbsp; PROCESSING OF INFORMATION
            </p>
            <p>
              2.1 &nbsp; &nbsp; You acknowledge and accept that any Information
              Collected (including Personal Information and Sensitive Personal
              Information as mentioned herein) shall be primarily processed in
              the United States by the Company subject to data protection
              regulations and applicable laws in the United Staes. However, We
              may store, collect, process and use Your data in countries other
              than the United States in compliance with applicable laws of such
              jurisdictions and We may enter into agreements with third parties,
              including Our Entities (in or outside of the United States), to
              store or process Your information or data for this purpose. You
              further acknowledge and accept that such third parties may have
              their own security standards to safeguard Your information or
              data. We will on commercial reasonable basis require from such
              third parties to adopt reasonable security standards to safeguard
              Your information/data in accordance with this Privacy Policy
              equivalent to the security standards maintained by Us. Your
              Personal Information (including Sensitive Personal Information)
              shall not be shared with or disclosed to any third parties by the
              Company except in the manner provided in this Privacy Policy. By
              agreeing to this Privacy Policy, You acknowledge and accept that
              You are providing the Company with Your explicit consent to
              collect and process Your Information Collected in the manner and
              for the purpose(s) defined in this Privacy Policy.
            </p>
            <p>
              2.2. &nbsp; &nbsp; We collect and process Your Personal
              Information in the manner provided in this Privacy Policy in
              accordance with applicable laws where this: (i) is necessary for
              and in connection with the purposes mentioned in this Privacy
              Policy (ii) is necessary for the performance of a contract for
              which Company and User are parties, (iii) is information which You
              have given Us consent to collect and process, or (iv) is necessary
              for compliance with a legal obligation to which We are subject.
            </p>
            <p>
              2.3. &nbsp; &nbsp; In case You have any concerns in the processing
              of Your Personal Information, please reach out to Our Grievance
              Officer in the manner provided in this Privacy Policy.
            </p>
            <p
              style={{
                fontFamily: "NunitoBlack",
                fontSize: "20px",
                color: "#f9c130",
              }}
            >
              3. &nbsp; &nbsp; INFORMATION COLLECTED
            </p>
            <p>
              3.1. &nbsp; &nbsp; You acknowledge and accept that the Company may
              collect Your information (including Your Personal Information and
              Sensitive Personal Information as listed below) of the nature
              mentioned herein from You for and in connection with the purposes
              mentioned herein in the course of, or as a result of, providing
              Services to You through the Platform and through Your use of the
              Platform (collectively “Information Collected”). Subject to clause
              1.8 herein above, We may collect the Information Collected in the
              following ways: as information submitted or supplied to Us by
              Users on the Platform; as information automatically tracked by Us
              during Users navigation on the Platform; and/or as communicated to
              Us via e-mail or other electronic mode in the manner provided in
              this Privacy Policy. Further, We may combine and process the
              Information Collected along with any other information about You,
              which is available to Us in the public domain or which You have
              otherwise provided to Us.
            </p>
            <p>
              3.2. &nbsp; &nbsp; We may collect Personal Information such as
              Your name, username, e-mail address and other details associated
              with Your User profile when You sign-up on the Platform for the
              Services. We may collect certain Personal Information linked to
              the e-mail account used by You to sign-up for Services on Our
              Platform, principally, the username and profile details provided
              by You at the time of sign-up.
            </p>
            <p>
              3.3. &nbsp; &nbsp; We may collect Personal Information and
              non-personal information about You including details of Your IP
              address, mobile device and any other statistical and technical and
              other information that may be required or be related to rendering
              the Services in an efficient and timely manner or to verify Your
              account with Us. Certain information and technical data about Your
              hardware devices and geographic location may be automatically
              collected when You access or register on the Platform. We may also
              collect information about Your activity on the Platform, such as
              information about Your account usage, as well as information about
              how You interact with the Platform and Your preferences.
            </p>
            <p>
              3.4. &nbsp; &nbsp; We collect communications between You and the
              Company, and any related information. If You communicate with Us
              through electronic means in the manner described in this Privacy
              Policy, (such as via e-mail), You accept that any information,
              including Personal Information, provided in such communication,
              such as Your contact details, may be collected by Us.
            </p>
            <p>
              3.5. &nbsp; &nbsp; The Personal Information We collect from You
              may include (as may be applicable) “sensitive personal data or
              information” as defined under the SPDI Rules, principally, the
              details of Your password for Your account with Us and other
              details as the User may communicate or submit to Us. As defined
              under SPDI Rules, and for the purpose of this Privacy Policy,
              reference to “sensitive personal data or information” (“Sensitive
              Personal Information”) herein shall mean Personal Information
              relating to: passwords; financial information such as bank
              accounts, credit and debit card details or other payment
              instrument details; physical, physiological and mental health
              condition; sexual orientation; medical records and history;
              biometric information; information received by Us under lawful
              contract or otherwise. It is clarified that if any such
              information about You is freely available in the public domain, it
              shall not comprise Sensitive Personal Information for the purpose
              of this Privacy Policy.
            </p>
            <p>
              3.6. &nbsp; &nbsp; We collect the Personal Information (including
              Sensitive Personal Information) that You choose to share with Us
              in the course of or for and in connection with the purposes
              mentioned herein including any other details about Yourself which
              You provide to the Company. By choosing to provide such
              information You consent to Our processing of that information in
              the manner mentioned in this Privacy Policy. We may also collect
              certain Personal Information from observing Your performance, Your
              actions and/or Your feedback in relation to the Platform and/or
              the Services.
            </p>
            <p>
              3.7. &nbsp; &nbsp; All the above Information Collected is stored
              or used by Us only for the purposes mentioned herein. We use the
              Information Collected for the Platform and Services in the manner
              mentioned in the Privacy Policy. Except for the lawful disclosures
              mentioned to be made by Us in the Privacy Policy, We do not
              disclose or share Your Personal Information including Sensitive
              Personal Information with any third-parties.
            </p>
            <p>
              3.8. &nbsp; &nbsp; Other than as provided in this Privacy Policy,
              We do not collect or process any Personal Information including
              Sensitive Personal Information of Users, including any of Your
              financial or payment related details. All payments made or
              received by You in connection with the Services offered on the
              Platform are processed and facilitated by the relevant third-party
              payment processor(s), the names of which We mention on the
              Platform, which We have engaged as Our Service Provider(s) for
              this purpose (“Payment Service Provider(s)”). Users to note that
              the relevant Payment Service Provider engaged by Us may collect
              Your Personal Information including any Sensitive Personal
              Information User may submit in connection with payment purposes as
              and when the User opts to makes or collect any payment in
              connection with the Services subject to the independent terms of
              use and privacy policy maintained by the Payment Service Provider.
            </p>
            <p
              style={{
                fontFamily: "NunitoBlack",
                fontSize: "20px",
                color: "#f9c130",
              }}
            >
              4. TRANSFER AND DISCLOSURE OF INFORMATION
            </p>
            <p>You acknowledge and accept the following: </p>
            <p>
              4.1. &nbsp; &nbsp;The Company only collects, uses, and processes
              Your Personal Information (including Sensitive Personal
              Information) for the purposes mentioned herein or otherwise as
              part of Our Agreement with You. The Company does not disclose or
              transfer Your Personal Information to other third parties without
              Your consent. The Company may disclose or transfer Your Personal
              Information (including Sensitive Personal Information) to third
              parties only in the manner and for the purposes mentioned
              hereinbelow.
            </p>
            <p>
              4.2. &nbsp; &nbsp;Other than is specifically stated in this
              Privacy Policy, We will only disclose or transfer Your Personal
              Information (including Sensitive Personal Information) in the
              event required to do so under applicable laws, rules and
              regulations or under directions from a law enforcement agency,
              governmental official, legal authority or pursuant to similar
              requirements applicable to Us. The Company may disclose or
              transfer Your Personal Information (including Sensitive Personal
              Information) in its sole discretion in accordance with this
              Privacy Policy when We deem this necessary in order to protect Our
              rights or the rights of other persons and Users, to prevent harm
              to such persons or User or property, to fight fraud and credit
              risk, or to enforce or apply the Privacy Policy and Agreement, as
              and when deemed necessary in line with applicable laws.
            </p>
            <p>
              4.3 &nbsp;&nbsp; We may disclose and transfer Your Personal
              Information (including Sensitive Personal Information) in the
              manner mentioned above only if required to do so by law or in the
              good faith belief that such disclosure is reasonably necessary to
              respond to court orders or for other legal processes under
              applicable laws. We may disclose and transfer and share Your
              Personal Information with government or judicial or other
              competent legal bodies (such as law enforcement agencies) in the
              good faith belief that such disclosure is reasonably necessary to
              enforce Our Agreement, respond to claims or orders or notices or
              other lawful requisitions or for purpose of compliance with
              applicable laws and regulations. Such transfer or disclosure shall
              be for lawful purposes and made subject to applicable laws in the
              United States.
            </p>
            <p>
              4.4. &nbsp; &nbsp;The Company may disclose, transfer, and share
              Your Personal Information (including Sensitive Personal
              Information) with third parties such as the Entities in line with
              Our business purposes including business research, analysis, and
              development in connection with the Services provided on the
              Platform. We may disclose and transfer Your Personal Information
              (including Sensitive Personal Information) to third parties (such
              as Entities and Business Partners) to facilitate the restructuring
              of Our business subject to Your consent in the manner mentioned in
              this Privacy Policy. Such disclosure and transfer are undertaken
              by Us subject to Your consent and the Agreement for lawful
              purposes in line with this Privacy Policy. In relation, to Our
              business, We may share, disclose and transfer Your Personal
              Information (including Sensitive Personal Information) for the
              purpose of obtaining professional advisory or services such as in
              relation to tax, regulatory and legal compliances, or in case of
              any major event such as merger, acquisition, sale and/or transfer
              of assets, or in case of any force majeure event, or as part of
              any merger, sale of Company assets or acquisition, or in the event
              of insolvency, bankruptcy, or receivership to Our professional
              advisors, consultants, Entities or other third parties. Such
              transfer shall be made subject to Your consent in the manner
              specified to You under the Privacy Policy. The transfer of Your
              Personal Information (including Sensitive Personal Information) to
              other third parties in the manner mentioned will only be done once
              it is ensured that the third party receiving such information has
              implemented the same level of security practices as We have.
            </p>
            <p
              style={{
                fontFamily: "NunitoBlack",
                fontSize: "20px",
                color: "#f9c130",
              }}
            >
              5. &nbsp; &nbsp; USE OF INFORMATION COLLECTED
              <br />
            </p>
            <p>
              You acknowledge and accept the following:&nbsp;
              <br />
              5.1. &nbsp; &nbsp;We use the Personal Information (including
              Sensitive Personal Information) We collect from You (as mentioned
              herein above) only for and in connection with the Services and the
              business transactions between You and the Company on the Platform
              in the manner mentioned herein subject to the applicable laws.
            </p>
            <p>
              5.2. &nbsp; &nbsp;Your Personal Information and Sensitive Personal
              Information (such as the password associated with Your account
              with Us) is principally used by Us for creating and maintaining
              Your User account on the Platform and for offering You the
              Services. We may combine Your Personal Information (including
              Sensitive Personal Information) and use and process it along with
              other information about You that We may have collected
              automatically through Your access or use of Our Platform,
              information about You in the public domain, as well as any other
              information (such as Personal Information including Sensitive
              Personal Information) You may choose to provide Us in the manner
              mentioned herein.
            </p>
            <p>
              5.3. &nbsp; &nbsp;We may also use Personal Information (including
              Sensitive Personal Information) to contact You and share
              additional and/or upcoming information with You regarding: any
              changes made by Us in the Services or Platform; any aspects which
              are likely to impact the Services or Platform; Our requirements or
              instructions for and in relation to the Platform or Services and
              the scope thereof; to enforce the Agreement or for other important
              notifications in this regard; and for any other purpose as may be
              specified to You as part of Our Agreement or otherwise specified
              to You in the written communication You receive from Us from time
              to time.
            </p>
            <p>
              5.4 &nbsp; &nbsp; We may also use Your Personal Information
              (including Sensitive Personal Information) to the extent We are
              lawfully mandated or required to do so under applicable laws and
              for lawful purposes in accordance with this Privacy Policy and the
              applicable laws, such as for the purpose of responding to the
              judicial process, providing information to law enforcement
              agencies or any government agency in connection with a
              query/investigation as permitted by law, to identify security
              breaches and attacks, investigate, prevent, and take action on
              illegal or suspected fraud or money laundering activities and
              conduct forensic audits as part of internal or external audit or
              investigation as required by law or government bodies or agencies
              located within the United States or outside jurisdictions.
            </p>
            <p>
              5.5. &nbsp; &nbsp;We use Your Personal Information only for
              legitimate purposes under the applicable laws for and in
              connection with Our business purposes, which generally include the
              following:
            </p>
            <p>
              5.5.1. &nbsp; &nbsp;to contact You as and when necessary;
              <br />
              5.5.2. &nbsp; &nbsp;to maintain any registered accounts that You
              may hold with Us;
              <br />
              5.5.3. &nbsp; &nbsp;for verification or authentication of Your
              account;
              <br />
              5.5.4. &nbsp; &nbsp;to customize the content of Our Platform for
              You;
              <br />
              5.5.5. &nbsp; &nbsp;to gather broad demographic and statistical
              information about Your activity on Our Platform;
              <br />
              5.5.6. &nbsp; &nbsp;to request for reviews of Our Platform and/or
              Services, or any other improvements thereto;
              <br />
              5.5.7. &nbsp; &nbsp;to prevent any misuse or abuse of Your account
              and information and to detect and protect against occurrence of
              error, fraud and other criminal activity on the Platform;
              <br />
              5.5.8. &nbsp; &nbsp;for responding to the judicial process and
              providing information to law enforcement agencies or any
              government agency in connection with a query/investigation on
              matters as permitted by law in the manner mentioned herein;
              <br />
              5.5.9. &nbsp; &nbsp;for Our business requirements, including for
              record keeping, reports, data processing, statistical or risk or
              other analysis, for review, for improvement of the Platform and
              Services, to help diagnose problems with Our servers, to resolve
              disputes or complaints pertaining to Our Platform and Services,
              troubleshoot problems, to enforce this Privacy Policy and to
              administer Our Platform and Services; and
              <br />
              5.5.10. &nbsp; &nbsp;for any other purposes as detailed herein or
              as We may detail to You at the time of collection of Your
              information or may communicate to You in writing.
            </p>
            <p>
              5.6. &nbsp; &nbsp;We may use Your Personal Information for
              marketing and advertising the Platform and Our Services and
              certain third-party products and services (including of Our
              Entities) to You (such as by displaying advertisements and links
              to third party websites on the Platform in the manner mentioned
              herein). Prior to any direct marketing or commercial operation
              (for example for sending the newsletters or commercial offers), We
              will first obtain the User’s consent, either upon creation of an
              account by the User on the Platform or later by allowing the User
              to indicate User’s choice in the account settings. The User may
              withdraw User’s consent to such marketing at any time, directly by
              clicking on the unsubscribe link available on each communication
              received, or by modifying Your account settings on the Platform,
              or by reaching out to Us using the “Contact Us” form available on
              the Platform.
            </p>
            <p>
              5.7. &nbsp; &nbsp;We re-iterate that We do not use or process Your
              Personal Information, including Your Sensitive Personal
              Information (such as any of Your financial details, including but
              not limited to Your bank account details, credit or debit card
              details and other payment details), for the purpose of any
              payments made or received in connection with the Services on the
              Platform. It is reiterated that such Personal Information, if
              submitted by the User in connection with the Services, will be
              directly collected and processed by the Payment Service Provider
              engaged by Us for this purpose. Users to note that the relevant
              Payment Service Provider engaged by Us shall directly collect the
              Personal Information including Sensitive Personal Information that
              User may submit in connection with payment purposes when the User
              opts to makes or collect any payment in connection with the
              Services subject to the independent terms of use and privacy
              policy maintained by the Payment Service Provider.
            </p>
            <p
              style={{
                fontFamily: "NunitoBlack",
                fontSize: "20px",
                color: "#f9c130",
              }}
            >
              6. &nbsp; &nbsp;REVIEW AND CORRECTION OF INFORMATION
            </p>
            <p>You acknowledge and accept the following:</p>
            <p>
              6.1. &nbsp; &nbsp;We grant Users the opportunity to review,
              correct and amend the Personal Information (including Sensitive
              Personal Information) User has provided to Us and submitted on the
              Platform. You may review and amend details associated with Your
              account and profile with Us through accessing Your account with Us
              or by contacting Us in accordance with this clause. You may
              intimate Us of any omissions or errors in any other Personal
              Information that You may have previously submitted to Us by
              filling out the “Contact Us” form available at Our Platform and
              may request for correction or amendment to any Personal
              Information that You consider to be incorrect or wrong. We shall
              process such requests from the User in accordance with applicable
              laws in the United States. Upon receipt of a verifiable request
              from You, We will use commercially reasonable efforts to correct
              the inaccurate Personal Information taking into account the nature
              of the information and the purposes of the processing and in
              accordance with applicable laws and regulations.
            </p>
            <p>
              6.2. &nbsp; &nbsp;You acknowledge and accept that We are not
              responsible for the authenticity of any Personal Information
              (including Sensitive Personal Information) that You provide to Us.
              You are solely and exclusively responsible for providing Us
              information about You that is true, authentic, and correct in all
              aspects and particulars. If You provide inaccurate or false
              information to Us, You shall be liable to indemnify and hold
              harmless the Company (and its officers, directors, contractors or
              agents and any third party relying on the information provided by
              You) in the event You are in breach of this Privacy Policy. You
              shall have the sole responsibility to intimate Us and request
              correction of inaccurate Personal Information maintained by the
              Company about You.
            </p>
            <p
              style={{
                fontFamily: "NunitoBlack",
                fontSize: "20px",
                color: "#f9c130",
              }}
            >
              7. &nbsp; &nbsp;INFORMATION STORAGE AND SECURITY
            </p>
            <p>You acknowledge and accept the following:</p>
            <p>
              7.1. &nbsp; &nbsp;The security of Your Personal Information
              (including Sensitive Personal Information) is important to Us and
              We have implemented commercially reasonable robust physical,
              managerial, operational, and technical security measures to
              protect the loss, misuse, and alteration and to preserve the
              security of Your Personal Information as may be in Our possession.
              We follow leading industry standards to protect the Personal
              Information submitted to Us, both during transmission and once We
              receive it, in the manner provided in this Privacy Policy. The
              Personal Information (including Sensitive Personal Information) We
              collect is stored in electronic form but may also be converted to
              physical form from time to time, if deemed necessary. We take
              necessary precautions to protect Your Personal Information both
              online and off-line and implement reasonable security practices
              and measures that are commensurate with respect to the information
              being collected and the nature of Our business.
            </p>
            <p>
              7.2. &nbsp; &nbsp;All Personal Information (including Sensitive
              Personal Information) collected through Our Platform is securely
              transmitted to and stored by Us in Our primary data storage
              facility (along with a backup storage option). To ensure secure
              storage of Your data Our database is stored on servers secured and
              protected behind a firewall. Our servers are hosted on Amazon Web
              Services (AWS) which employs industry-leading security protocols
              for safeguarding Your Personal Information. Further, access to
              Your data is limited by Us to eradicate and mitigate risks. We
              employ data encryption measures to protect Your Personal
              Information on a per User basis and ensure that only authorized
              devices within the Company’s secure network can access Your
              Personal Information. The access to Your Personal Information is
              limited to select executives of the Company. As an additional
              security measure, We require such executives to authenticate
              themselves by using two-factor authentication in order to access
              Your Personal Information. As an additional defense mechanism to
              prevent any potential security breaches and to counter the threat
              of viruses and malware, We install and maintain comprehensive
              virus protection software on all Our secured devices. Further, We
              conduct regular audits of the data We collect, process and store
              to ensure Our compliance with established security standards and
              to promptly identify and address any vulnerabilities and to
              protect the loss, misuse and alteration of the Personal
              Information in Our possession.
            </p>
            <p>
              7.3. &nbsp; &nbsp;Although We make best possible efforts to store
              Your Personal Information (including Sensitive Personal
              Information) in a secure operating environment that is not open to
              the public, You understand that there is no such thing as complete
              security, and We cannot guarantee safety or security of Your
              information in case events beyond Our control occur, both during
              transmission of Your information and once We receive it and thus
              cannot guarantee that there will be no unintended disclosures of
              Your information. If We become aware that Your Personal
              Information (including Sensitive Personal Information) has been
              disclosed in a manner not in accordance with this Privacy Policy,
              We will use reasonable efforts to notify You of the nature and
              extent of such disclosure as soon as reasonably possible and as
              permitted by law. We encourage You to follow certain security
              measures on Your part during and after the transmission of Your
              Personal Information (including Sensitive Personal Information) as
              may be reasonable and appropriate and as may be communicated and
              requested to You by Us in writing in the manner mentioned herein.
              In general, We encourage the User to follow certain security
              measures on their part, including: if using a computer in a public
              location, to always log out and close the website browser when You
              complete Your online session; keep Your account details and
              passwords private; frequently change Your password; avoid using
              the same password for multiple online accounts.
            </p>
            <p>
              7.4. &nbsp; &nbsp;We retain Information Collected for as long as
              is reasonably necessary for the purposes listed in this Privacy
              Policy to provide You with access to Our Services and Platform.
              However, You acknowledge and agree that We may retain certain
              Personal Information (including Sensitive Personal Information) of
              User for a longer duration of time at Our discretion for other
              purposes, strictly purposes which are in line with Our business
              operations, such as research and development in connection with
              the Platform and Services and for any regulatory, tax or
              accounting requirements and other compliances We are subject to
              under applicable laws.
            </p>
            <p
              style={{
                fontFamily: "NunitoBlack",
                fontSize: "20px",
                color: "#f9c130",
              }}
            >
              8. &nbsp; &nbsp;USER CONSENT AND PERMISSION
              <br />
            </p>
            <p>
              You acknowledge and accept the following:&nbsp;
              <br />
              8.1. &nbsp; &nbsp;User may communicate any grievances or concerns
              regarding User’s Personal Information (including Sensitive
              Personal Information) to the Company by reaching out to Our
              Grievance Officer in the manner provided in this Privacy Policy.
              In case the User opts to decline to provide consent or withdraw
              any consent granted to Us in respect of collection or processing
              of the User’s Sensitive Personal Information, the User should
              clearly intimate Us of such request in writing by filling out the
              “Contact Us” form available at Our Platform. In such case the User
              acknowledges and agrees that the User’s actions may interfere with
              or render it impossible for Us to offer any further Services to
              You and We may be forced to limit, suspend or terminate Your
              access to the Platform and/or the Services.
            </p>
            <p>
              8.2. &nbsp; &nbsp;User hereby agrees and acknowledges that We
              shall not be held liable in any manner whatsoever if We are unable
              to perform Our Services or if there is a deficiency in the
              Services provided by Us due to any Personal Information (including
              Sensitive Personal Information) provided by a User which is
              incorrect or due to any withdrawal of User consent. User
              acknowledges and agrees to indemnify and hold Us (and Our
              employees, consultants, directors, representatives and/or
              affliates) harmless from any complaints, legal proceedings or
              claims filed or initiated by any third party against Us due to any
              breach by the User of the terms of this Privacy Policy.
            </p>
            <p>
              8.3. &nbsp; &nbsp;We take data privacy seriously and are committed
              to ensuring the security and confidentiality of our users'
              information. Our data retention and deletion policy are designed
              to empower users with control over their personal data. Users have
              the right to request the deletion of their data, and we have a
              dedicated grievance officer available to address any such queries
              or fill out contact us form specifically stating your request. We
              believe in transparency and accountability when it comes to data
              management, and we're here to assist our users in making informed
              choices about their data. Rest assured, your data is in safe
              hands, and we are committed to honoring your requests for data
              deletion promptly and securely.
            </p>
            <p>
              8.4. &nbsp; &nbsp;We provide Users with the opportunity to opt-out
              of receiving non-essential (promotional, marketing related)
              communications from Us, once You sign-up on the Platform, by
              sending an e-mail to the following email address:
              contactus@wolfwinplay.com. To the extent We use Your Personal
              Information to market to You, We will provide You the ability to
              opt-out of such uses. In case, You choose to do so then Your
              access to the Platform may be limited, or We might not be able to
              provide the Services to You.
            </p>
            <p
              style={{
                fontFamily: "NunitoBlack",
                fontSize: "20px",
                color: "#f9c130",
              }}
            >
              9. &nbsp; &nbsp;CHANGES TO PRIVACY POLICY
            </p>
            <p>
              You acknowledge and accept the following:&nbsp;
              <br />
              9.1. &nbsp; &nbsp;You acknowledge and accept that the Company may
              update this Privacy Policy at any time, with or without advance
              notice. In the event there are significant changes in the way
              Company treats User’s Personal Information, or in the Privacy
              Policy itself, Company will display a notice on the Platform and
              may intimate Users concerning relevant changes in the Privacy
              Policy via an e-mail, so that You may review the changed terms
              prior to continuing to use the Platform and Our Services.
            </p>
            <p>
              9.2. &nbsp; &nbsp;If You object to any of the changes to Our
              Privacy Policy and You no longer wish to avail the Services, You
              are entitled to deactivate Your account with Us and refrain from
              using or accessing the Platform and Our Services. You may also
              reach out to Us by filling out the “Contact Us” form available at
              Our Platform in this regard. If You have any complaints or issues
              concerning changes to Our Privacy Policy, please reach out to Our
              Grievance Officer in the manner provided in this Privacy Policy.
            </p>
            <p>
              9.3. &nbsp; &nbsp;Unless stated otherwise herein or otherwise
              informed to You in writing by the Company, the Company’s current
              Privacy Policy applies to all information that the Company has
              about You. If You choose to maintain Your account with Us and/or
              use the Platform or the Services in any manner after any notice of
              changes or updates made by Us in Privacy Policy is published on
              the Platform or informed to You over electronic communication via
              an e-mail in the manner provided herein, then You hereby consent
              to the changed terms of Our Privacy Policy.
            </p>
            <p
              style={{
                fontFamily: "NunitoBlack",
                fontSize: "20px",
                color: "#f9c130",
              }}
            >
              10. &nbsp; &nbsp;GRIEVANCE REDRESSAL
            </p>
            <p>
              10.1. &nbsp; &nbsp;In case You have queries or concerns pertaining
              to the Privacy Policy or Our use of Your Personal Information
              (including Sensitive Personal Information), You can direct any
              questions or complaints to Us by contacting Our designated
              grievance officer (“Grievance Officer”) in writing via e-mail
              and/or by post using the contact details mentioned herein below.
              Any communication pertaining to any discrepancies, points of
              concern or grievances as regards the Privacy Policy and any
              complaints, abuse, or concerns with regards to content and/or
              breach of the terms herein must be immediately informed to the
              Grievance Officer (using the contact information mentioned below)
              in writing. The Company shall not be responsible in the event that
              You address any communication to any non-designated person in this
              regard.
            </p>
            <p>
              Name : Dhrumit Kabariya &nbsp;
              <br />
              Office Address : 241 Forest Ave, Paramus, NJ 07652
              <br />
              Email Address :
              <a href="grievanceofficer@wolfwinplay.com">
                grievanceofficer@wolfwinplay.com
              </a>
            </p>
            <p>
              You acknowledge and accept that You will provide Our Grievance
              Officer with all necessary information and/or documents to enable
              the Grievance Officer to resolve the issue.
              <br />
              10.2. &nbsp; &nbsp;The grievances received under this paragraph
              shall be dealt with in adherence to the timelines specified under
              the Information Technology Act, 2000 and the applicable rules
              notified thereunder. We will investigate and attempt to resolve
              any queries regarding the use or disclosure of Your Personal
              Information (including Sensitive Personal Information as soon as
              possible). While We try to respond to all legitimate requests as
              soon as possible from the date of receipt of the query,
              occasionally it may take Us longer than the same if Your request
              is particularly complex, or You have made a number of requests, or
              You have not provided all necessary information/documents to
              enable the Grievance Officer to resolve the issue. In this case,
              We will notify You and keep You updated.
            </p>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
